import React from "react";

const ReservationTotalpage = () => {
  return <>ReservationTotalpage</>;
};

export default ReservationTotalpage;
